import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { serverURL } from '../../constants';

const CourseTable = ({ datas }) => {
    const [search, setSearch] = useState('');

    const filtered = datas.filter(c =>
        (c.mainTopic || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.type || '').toLowerCase().includes(search.toLowerCase())
    );

    async function handleDelete(courseId) {
        if (window.confirm('Delete this course? This cannot be undone.')) {
            try {
                await axios.post(serverURL + '/api/deletecourse', { courseId }, { headers: { 'x-admin-email': sessionStorage.getItem('email') } });
                toast.success('Course deleted');
                window.location.reload();
            } catch (error) {
                toast.error('Error deleting course');
            }
        }
    }

    function formatDate(date) {
        if (!date) return '—';
        return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    return (
        <div>
            <div className='flex items-center justify-between mb-4'>
                <div>
                    <input
                        className='border border-gray-300 rounded-lg px-3 py-2 text-sm w-72'
                        placeholder='Search courses...'
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    <span className='ml-3 text-sm text-gray-400'>{filtered.length} courses</span>
                </div>
            </div>

            {filtered.length === 0 ? (
                <div className='bg-white rounded-lg border border-gray-200 p-12 text-center'>
                    <p className='text-gray-400'>No courses found</p>
                </div>
            ) : (
                <div className='bg-white rounded-lg border border-gray-200 overflow-hidden'>
                    <table className='w-full'>
                        <thead className='bg-gray-50 border-b border-gray-200'>
                            <tr>
                                <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Topic</th>
                                <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Type</th>
                                <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Created</th>
                                <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Status</th>
                                <th className='text-left px-4 py-3 text-xs font-bold text-gray-500 uppercase'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className='divide-y divide-gray-100'>
                            {filtered.map(course => (
                                <tr key={course._id} className='hover:bg-gray-50 transition-colors'>
                                    <td className='px-4 py-3'>
                                        <p className='text-sm font-medium'>{course.mainTopic || 'Untitled'}</p>
                                        <p className='text-xs text-gray-400'>ID: {course._id.slice(-8)}</p>
                                    </td>
                                    <td className='px-4 py-3'>
                                        <span className={`text-xs font-medium px-2 py-1 rounded-full ${course.type === 'video & text course' ? 'bg-purple-50 text-purple-700' : 'bg-blue-50 text-blue-700'}`}>
                                            {course.type || 'text'}
                                        </span>
                                    </td>
                                    <td className='px-4 py-3 text-sm text-gray-500'>{formatDate(course.date)}</td>
                                    <td className='px-4 py-3'>
                                        <span className={`text-xs font-medium px-2 py-1 rounded-full ${course.completed ? 'bg-green-50 text-green-700' : 'bg-amber-50 text-amber-700'}`}>
                                            {course.completed ? 'Completed' : 'In Progress'}
                                        </span>
                                    </td>
                                    <td className='px-4 py-3'>
                                        <button onClick={() => handleDelete(course._id)} className='text-xs font-medium text-red-600 hover:text-red-800'>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CourseTable;
